<h3 mat-dialog-title>Brak możliwości zamówienia oferty</h3>

<mat-dialog-content>
  Na Twoim koncie nie ma żadnego dostawcy telefonu z możliwością zmiany oferty. Dodaj dostawcę z kategorii Telefon, dla
  którego umowa wkrótce się kończy, aby móc poznać dedykowaną ofertę.
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button matDialogClose mat-button>Zamknij</button>
</mat-dialog-actions>
